import React from "react";

const CPPGuide = () =>{
    sessionStorage.setItem('reportStatus' , 'false');
    return ( 
        <>
            <h3 className="font-24 font-semi-bold mb-36">Top 5 CPP Impact Variables</h3>
            <p>This graph refers to the impact on Cost per part (CPP) by the following variables: </p>
            <ol>
                <li>Utilization</li>
                <li>Material Price</li>
                <li>Build Rate</li>
                <li>Post Processing</li>
                <li>Refreshing Rate</li>
            </ol>
            <img src="/assets/cpp-guide-1.png" alt="" className="img-fluid" />
            <p>This show the variation in each variable if you change the variable by 10% and 20%. Note this is to have a positive change on cost per part for e.g. 10% increase in utilization and 10% decrease in material price.</p>
        </>
    )
}

export default CPPGuide;